import { Injectable, Injector } from "@angular/core";

import { LogService } from "@bitwarden/common/abstractions/log.service";
import { ConsoleLogService } from "@bitwarden/common/services/consoleLog.service";
import { ReferenceDataService } from "@bitwarden/web-vault/app/services/DataService/reference-data/reference-data.service";

import { Transaction } from "../../../models/data/blobby/transaction.data";
import { PreferenceService } from "../../DataService/preference/preference.service";
import { CalculationServiceAbstraction } from "../calculation.service.abstraction";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";

@Injectable({
  providedIn: "root",
})
export class TransactionNormalizeService implements CalculationServiceAbstraction {
  protected logService: LogService = new ConsoleLogService(false);

  /**
   * @deprecated - this method should no longer be used as we are moving to TransactionView and state management
   * model. We should no longer need to normalize transactions using a service and should use the normalizeTransaction
   * class instead. The reference data needs to come from the referenceServiceStore.
   * @param transaction
   */
  async normalizeImportedTransaction(transaction: Transaction): Promise<void> {
    // await this.setupNormalizeTransactionClass();
    // logic moved to NormalizeTransaction class when web workers were introduced
    // return await this.normalizeTransaction.normalizeImportedTransaction(transaction);
    return;
  }
}
